import React, {Component} from 'react';

export default class Alert extends Component {
  state = {
    timeoutHandle: null
  }

  componentDidMount() {
    const {index, timer, dismissAlert} = this.props;
    if (timer) {
      // TODO: Binding on index when index can change is problematic.
      const timeoutHandle = setTimeout(dismissAlert.bind(null, index), timer);
      this.setState({timeoutHandle: timeoutHandle});
    }
  }

  componentWillUnmount() {
    clearTimeout(this.state.timeoutHandle);
  }

  render() {
    const {index, message, type, dismissable, dismissAlert} = this.props;

    return (
      <div className={'alert alert-dismissible fade-in alert-'+type} role="alert">
        {dismissable && (
          <button type="button" className="close" aria-label="close" onClick={dismissAlert.bind(null, index)}>
            <span aria-hidden="true">&times;</span>
          </button>
        )}
        {message}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/Alert.jsx